import { isTest, isLocal } from '~/src/env-constants';

// Config
export default {
  enabled: !isTest || !isLocal,
  accountID: process.env.NEXT_PUBLIC_TARGET_CUSTOMER,
  sentryDsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_APP_TIER,
  releaseName: `${process.env.NEXT_PUBLIC_APP_NAME}@${process.env.NEXT_PUBLIC_RELEASE_NAME}`,
};
